import {SessionStorageUtil} from './browserStorageSanitizer.js';

/* global NaN */

export var TimeUtil = {

	parseDate: function(inputString) {
		if (!inputString || inputString === '') {
			return null; 
		}
		if (inputString.endsWith && inputString.endsWith('0:0:0')) {
			inputString = inputString.replace('0:0:0', '00:00:00');
		}
		
		//it seems that only ISO date are safe (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse)
		//The API just returns ISO so this maybe fine		
		return new Date(inputString);
	},
	
	formatDateStandard: function(date, options) {
		if (!date) {
			return date;
		}
		if ((typeof date === 'string')) {
			date = this.parseDate(date);
		}
		//return date.toLocaleString().replace(',', '') + ' ' + this.getLocalTimeZoneString(date);
		if (options && options.showUserTime) {	
			var userTime = date.toLocaleString('en-US', {	
			  hourCycle: "h23",
			  hour: '2-digit',
			  minute: '2-digit',
			  second: '2-digit',
			  timeZoneName: 'short', 
			  month: '2-digit',
			  day: '2-digit',
			  year: 'numeric'			
			}).replace(',', ''); 			
			return userTime;
		} else {
			var companyTimeZone = this.getCompanyTimeZone(date);
			
			var companyTime = date.toLocaleString('en-US', {
				hourCycle: "h23",
				hour: '2-digit',
				minute: '2-digit',
				second: '2-digit',
				timeZoneName: 'short',
				month: '2-digit',
				day: '2-digit',
				year: 'numeric',
				timeZone: companyTimeZone.zonename
			}).replace(',', ''); 
			return companyTime;
		}
	},

	/**
	 * Company timezone plus system (UTC) for detail views.
	 * Example: 08/05/2026 08:00:00 CDT (Company) / 08/05/2026 13:00:00 UTC (System)
	 */
	formatDateCompanyAndSystem: function(date) {
		if (!date) {
			return date;
		}
		if ((typeof date === 'string')) {
			date = this.parseDate(date);
		}
		if (!date || isNaN(date.getTime())) {
			return date;
		}
		var companyTime = this.formatDateStandard(date);
		var systemTime = date.toLocaleString('en-US', {
			hourCycle: 'h23',
			hour: '2-digit',
			minute: '2-digit',
			second: '2-digit',
			timeZoneName: 'short',
			month: '2-digit',
			day: '2-digit',
			year: 'numeric',
			timeZone: 'UTC'
		}).replace(',', '');
		return companyTime + ' (Company) / ' + systemTime + ' (System)';
	},

	/**
	 * True when the value looks like an API/ISO datetime string.
	 */
	looksLikeDateTimeValue: function(value) {
		if (value == null || value === '' || typeof value === 'boolean' || typeof value === 'number') {
			return false;
		}
		if (value instanceof Date) {
			return !isNaN(value.getTime());
		}
		if (typeof value !== 'string') {
			return false;
		}
		if (!/^\d{4}-\d{2}-\d{2}/.test(value) && !/^\d{4}-\d{2}-\d{2}T/.test(value)) {
			return false;
		}
		var parsed = this.parseDate(value);
		return parsed && !isNaN(parsed.getTime());
	},

	formatReportPeriodDate: function(date, isStart) {
		if (!date) {
			return date;
		}
		if ((typeof date === 'string')) {
			date = this.parseDate(date);
		}
		var companyTimeZone = this.getCompanyTimeZoneNameOnly();
		var year = date.toLocaleString('default', { year: 'numeric', timeZone: companyTimeZone });
		var month = date.toLocaleString('default', { month: '2-digit', timeZone: companyTimeZone });
		var day = date.toLocaleString('default', { day: '2-digit', timeZone: companyTimeZone });
		var time = isStart ? '00:00:00' : '23:59:59';
		var timeZoneLabel = date.toLocaleString('en-US', {
			timeZoneName: 'short',
			timeZone: companyTimeZone
		}).split(' ').pop();
		return month + '/' + day + '/' + year + ' ' + time + ' ' + timeZoneLabel;
	},
	
	getCompanyTimeZoneNameOnly: function() {
		//this loaded from the header.js (see that)
		var companyTimeZone = SessionStorageUtil.getItem('companyTimeZone');
		companyTimeZone = companyTimeZone || 'CST6CDT';
		if (companyTimeZone === 'undefined') {
			companyTimeZone = 'CST6CDT';
		}
		return companyTimeZone;
	},

	/**
	 * Secure Fuel Informix event data is stored as naive Central (CST6CDT) wall time.
	 */
	getSecureFuelDataTimeZone: function() {
		return 'CST6CDT';
	},
	
	getCompanyTimeZone: function(date) {	
		var companyTimeZone = this.getCompanyTimeZoneNameOnly();
		return {
			zonename: companyTimeZone,
			offset: this.getOffsetForTimeZone(companyTimeZone, date)
		};
	},
	
	getFullTimeZone: function(timezone, date) {		
		return {
			zonename: timezone,
			offset: this.getOffsetForTimeZone(timezone, date)
		};
	},	
	
	getOffsetForTimeZone: function(timeZone, date) {
		var rawDate =  Intl.DateTimeFormat('ia', {  
			timeZoneName: "longOffset", 
			timeZone: timeZone}).format(date);
		//'7/12/2024, GMT-05:00'
		var rawOffset = rawDate.split(' ')[1];
		return rawOffset.replace('GMT', '');
	},
	
	formatDateOnlyStandard: function(dateString) {
		if (!dateString) {
			return dateString;
		}		
		var date = this.parseDate(dateString);
		
		var companyTimeZone = this.getCompanyTimeZoneNameOnly();		
		var year = date.toLocaleString("default", { year: "numeric", timeZone: companyTimeZone});
		var month = date.toLocaleString("default", { month: "2-digit", timeZone: companyTimeZone });
		var day = date.toLocaleString("default", { day: "2-digit", timeZone: companyTimeZone });
		
		return month + '/' + day + '/' + year;
	},

	/**
	 * Billing cycle dates are persisted as UTC calendar dates. Format without applying
	 * the company timezone so midnight UTC does not shift to the prior local day.
	 */
	formatBillingCalendarDate: function(dateString) {
		if (!dateString) {
			return dateString;
		}
		var date = this.parseDate(dateString);
		var month = String(date.getUTCMonth() + 1).padStart(2, '0');
		var day = String(date.getUTCDate()).padStart(2, '0');
		var year = date.getUTCFullYear();
		return month + '/' + day + '/' + year;
	},

	normalizeBillingCalendarDateForSubmit: function(dateValue) {
		if (!dateValue) {
			return dateValue;
		}
		if (typeof dateValue === 'string' && dateValue.length >= 10) {
			return dateValue.substring(0, 10) + 'T00:00:00.000Z';
		}
		var date = this.parseDate(dateValue);
		var month = String(date.getUTCMonth() + 1).padStart(2, '0');
		var day = String(date.getUTCDate()).padStart(2, '0');
		var year = date.getUTCFullYear();
		return year + '-' + month + '-' + day + 'T00:00:00.000Z';
	},
	
	formatDateOnlyFromDate: function(date) {
		if (!date) {
			return date;
		}	

		var companyTimeZone = this.getCompanyTimeZoneNameOnly();		
		var year = date.toLocaleString("default", { year: "numeric", timeZone: companyTimeZone});
		var month = date.toLocaleString("default", { month: "2-digit", timeZone: companyTimeZone });
		var day = date.toLocaleString("default", { day: "2-digit", timeZone: companyTimeZone });		
		
		return month + '/' + day + '/' + year;
	},	
	
	formatDateForTimeField: function(date) {
		//vaadin date field needs a ISO format
		var isoDate = date.toISOString(); //note this will put the data in UTC time
		return isoDate.substring(0, isoDate.indexOf('T'));		
	},

	/**
	 * Formats a Vaadin date-picker parts object as MM/DD/YYYY.
	 * Month on the parts object is 0-based.
	 */
	formatDatePickerDate: function(dateParts) {
		if (!dateParts) {
			return '';
		}
		var month = String(dateParts.month + 1).padStart(2, '0');
		var day = String(dateParts.day).padStart(2, '0');
		var year = String(dateParts.year).padStart(4, '0');
		return month + '/' + day + '/' + year;
	},

	/**
	 * Adjusts a 2-digit year to the century closest to today (Vaadin-style window).
	 */
	adjustTwoDigitYear: function(year) {
		var today = new Date();
		var centuryBase = Math.floor(today.getFullYear() / 100) * 100;
		var candidate = centuryBase + year;
		if (candidate - today.getFullYear() > 50) {
			candidate -= 100;
		}
		if (today.getFullYear() - candidate > 50) {
			candidate += 100;
		}
		return candidate;
	},

	/**
	 * Builds a Vaadin date parts object when month/day/year form a real calendar date.
	 * Month is 0-based for Vaadin.
	 */
	buildDatePickerParts: function(monthOneBased, day, year) {
		if (monthOneBased === undefined || day === undefined || year === undefined) {
			return undefined;
		}
		if (isNaN(monthOneBased) || isNaN(day) || isNaN(year)) {
			return undefined;
		}
		var month = monthOneBased - 1;
		var testDate = new Date(year, month, day);
		if (testDate.getFullYear() !== year || testDate.getMonth() !== month || testDate.getDate() !== day) {
			return undefined;
		}
		return { day: day, month: month, year: year };
	},

	/**
	 * Parses typed date-picker input, including Ext-style shortcuts such as 0724 → 07/24/{current year}.
	 * Supports slash/dash/dot separated values and digit-only MMDD / MMDDYY / MMDDYYYY forms.
	 */
	parseDatePickerDate: function(text) {
		if (!text || !String(text).trim()) {
			return undefined;
		}

		var trimmed = String(text).trim();
		var today = new Date();
		var monthOneBased;
		var day;
		var year;
		var yearToken;

		if (/[\/\-.]/.test(trimmed)) {
			var parts = trimmed.split(/[\/\-.]/);
			if (parts.length === 3) {
				monthOneBased = parseInt(parts[0], 10);
				day = parseInt(parts[1], 10);
				yearToken = parts[2];
				year = parseInt(yearToken, 10);
				if (yearToken.length < 3 && year >= 0) {
					year = this.adjustTwoDigitYear(year);
				}
			} else if (parts.length === 2) {
				monthOneBased = parseInt(parts[0], 10);
				day = parseInt(parts[1], 10);
				year = today.getFullYear();
			} else if (parts.length === 1) {
				day = parseInt(parts[0], 10);
				monthOneBased = today.getMonth() + 1;
				year = today.getFullYear();
			}
		} else {
			var digits = trimmed.replace(/\D/g, '');
			if (!digits || digits !== trimmed) {
				return undefined;
			}

			if (digits.length === 1 || digits.length === 2) {
				day = parseInt(digits, 10);
				monthOneBased = today.getMonth() + 1;
				year = today.getFullYear();
			} else if (digits.length === 3) {
				// MDD
				monthOneBased = parseInt(digits.substring(0, 1), 10);
				day = parseInt(digits.substring(1, 3), 10);
				year = today.getFullYear();
			} else if (digits.length === 4) {
				// MMDD (e.g. 0724 → 07/24/current year)
				monthOneBased = parseInt(digits.substring(0, 2), 10);
				day = parseInt(digits.substring(2, 4), 10);
				year = today.getFullYear();
			} else if (digits.length === 6) {
				// MMDDYY
				monthOneBased = parseInt(digits.substring(0, 2), 10);
				day = parseInt(digits.substring(2, 4), 10);
				year = this.adjustTwoDigitYear(parseInt(digits.substring(4, 6), 10));
			} else if (digits.length === 8) {
				// MMDDYYYY
				monthOneBased = parseInt(digits.substring(0, 2), 10);
				day = parseInt(digits.substring(2, 4), 10);
				year = parseInt(digits.substring(4, 8), 10);
			} else {
				return undefined;
			}
		}

		return this.buildDatePickerParts(monthOneBased, day, year);
	},

	/**
	 * Enables Ext-style short date entry on a vaadin-date-picker or vaadin-date-time-picker.
	 */
	applyDatePickerI18n: function(datePickerElement) {
		if (!datePickerElement) {
			return;
		}
		var timeUtil = this;
		datePickerElement.i18n = Object.assign({}, datePickerElement.i18n, {
			formatDate: function(dateParts) {
				return timeUtil.formatDatePickerDate(dateParts);
			},
			parseDate: function(inputText) {
				return timeUtil.parseDatePickerDate(inputText);
			}
		});
	},

	/**
	 * Optional helper for cases that need a blank date with a seeded time (default 00:00:00).
	 * Use via ElementUtil create config: blankDateDefaultTime: true | 'HH:mm:ss'
	 * Also fills empty time when a date is chosen (Vaadin only commits a value when both parts are set).
	 */
	initDateTimePickerBlankDateWithTime: function(dateTimePicker, defaultTime) {
		if (!dateTimePicker) {
			return;
		}
		var timeValue = defaultTime || '00:00:00';

		var applyTimeIfEmpty = function() {
			var timePicker = dateTimePicker.__timePicker;
			if (timePicker && !timePicker.value) {
				timePicker.value = timeValue;
			}
		};

		var attachWhenReady = function() {
			var datePicker = dateTimePicker.__datePicker;
			var timePicker = dateTimePicker.__timePicker;
			if (!datePicker || !timePicker) {
				return false;
			}
			applyTimeIfEmpty();
			if (!dateTimePicker._blankDateTimeDefaultAttached) {
				dateTimePicker._blankDateTimeDefaultAttached = true;
				datePicker.addEventListener('change', applyTimeIfEmpty);
			}
			return true;
		};

		if (attachWhenReady()) {
			return;
		}

		customElements.whenDefined('vaadin-date-time-picker').then(function() {
			requestAnimationFrame(function() {
				if (attachWhenReady()) {
					return;
				}
				var attempts = 0;
				var timer = setInterval(function() {
					attempts++;
					if (attachWhenReady() || attempts > 40) {
						clearInterval(timer);
					}
				}, 25);
			});
		});
	},
	
	formatDateForDateLoadStriped: function(dateString) {
		return dateString.substring(0, dateString.indexOf('T'));	
	},
	
	formatDateStringToStandard: function(dataString) {
		//changes yyyy-MM-dd
		var split = dataString.split('-');
		return +split[1] + '/' + +split[2] + '/' + +split[0];
	},
	
	formatDateForDateLoad: function(dateString) {
		if (!dateString) {
			return dateString;
		}		
		var date = this.parseDate(dateString);
		//vaadin date field needs a ISO format (yyyy-MM-dd)		
		var companyTimeZone = this.getCompanyTimeZoneNameOnly();		
		var year = date.toLocaleString("default", { year: "numeric", timeZone: companyTimeZone});
		var month = date.toLocaleString("default", { month: "2-digit", timeZone: companyTimeZone });
		var day = date.toLocaleString("default", { day: "2-digit", timeZone: companyTimeZone });
		
		//return date.getFullYear() + '-' + (date.getMonth() + 1 ) + '-' + date.getDate();
		return year + '-' + month + '-' + day;
	},
	
	formatDateForDateTimeLoad: function(inDate) {
		return this.formatDateForDateTimeInTimeZone(inDate, this.getCompanyTimeZoneNameOnly());
	},

	formatDateForDateTimeInTimeZone: function(inDate, timeZoneId) {
		if (!inDate) {
			return inDate;
		}
		var date = inDate;
		if ((typeof inDate === 'string')) {
			date = this.parseDate(inDate);
		}
		if (!timeZoneId) {
			timeZoneId = this.getCompanyTimeZoneNameOnly();
		}

		//vaadin date field needs a ISO format (yyyy-MM-ddTHH:mm:ss)
		var year = date.toLocaleString('default', { year: 'numeric', timeZone: timeZoneId});
		var month = date.toLocaleString('default', { month: '2-digit', timeZone: timeZoneId });
		var day = date.toLocaleString('default', { day: '2-digit', timeZone: timeZoneId });
		var hour = date.toLocaleString('default', { hourCycle: 'h23', hour: '2-digit', timeZone: timeZoneId });
		var minute = date.toLocaleString('default', { minute: '2-digit', timeZone: timeZoneId });
		var second = date.toLocaleString('default', { second: '2-digit', timeZone: timeZoneId });

		return year + '-' + month + '-' + day + 'T' + hour + ':' + minute + ':' + second;
	},		
	
	formatDateForDateOnlySave: function(dateString) {
		if (!dateString) {
			return dateString;
		}			
		//date field (yyyy-MM-dd)
		var dataParts = dateString.split('-');
		var newDate = new Date();
		newDate.setUTCHours(23);
		newDate.setUTCMinutes(59);
		newDate.setUTCSeconds(59);
		newDate.setUTCMilliseconds(999);		
		newDate.setUTCFullYear(dataParts[0]);
		newDate.setUTCMonth(dataParts[1]-1);
		newDate.setUTCDate(dataParts[2]);		
		
		return newDate;	
	},	
	
	milliToDisplay: function(value) {
		var uptimeSecsTotal = Math.floor(value / 1000);
		var uptimeMin = Math.floor(uptimeSecsTotal / 60);
		var uptimeSecsReal = uptimeSecsTotal - (uptimeMin * 60);
		var uptimeHrs = Math.floor(uptimeMin / 60);
		var uptimeMinReal = uptimeMin - (uptimeHrs * 60);
		var uptimeMillis = value % 1000;
		return Math.round(uptimeHrs) + "hr(s) " + Math.round(uptimeMinReal) + " min(s) " + Math.round(uptimeSecsReal) + " sec(s) " + uptimeMillis + " ms";
	},	

	daysBetween: function(date1, date2) {		
		var differenceInTime = date2.getTime() - date1.getTime(); 
		var differenceInDays = differenceInTime / (1000 * 3600 * 24);		
		return Math.abs(differenceInDays);
	},

	startPreviousMonth: function() {
		var today = new Date();		
		var defaultStartDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);

		defaultStartDate.setUTCHours(0);
		defaultStartDate.setUTCMinutes(0);
		defaultStartDate.setUTCSeconds(0);
		defaultStartDate.setUTCMilliseconds(0);
		return defaultStartDate;
	},
	
	startCurrentMonth: function() {
		var defaultStartDate = new Date();
		defaultStartDate.setUTCDate(1);	
		defaultStartDate.setUTCHours(0);
		defaultStartDate.setUTCMinutes(0);
		defaultStartDate.setUTCSeconds(0);
		defaultStartDate.setUTCMilliseconds(0);
		return defaultStartDate;
	},
	
	startOfDayCompanyTime: function(dateString) {
		var companyTimeZone = this.getCompanyTimeZone(this.getDateFromDateString(dateString));
		
		//user time (yyyy-MM-dd)  Used in filters
//		var date = new Date(dateString);
//		
//		var year = date.toLocaleString("default", { year: "numeric" });
//		var month = date.toLocaleString("default", { month: "2-digit" });
//		var day = date.toLocaleString("default", { day: "2-digit" });
		
		//(yyyy-MM-ddTHH:mm:ss-05:00)
		var dataRawString = dateString + 'T00:00:00' + companyTimeZone.offset;
		//date = new Date(dataRawString);
		return dataRawString;
	},	
	
	// This will be in user time
	getDateFromDateString: function(dateString) {
		//This will be in user time (could be side effect on edge cases around the time changes for a hour or 2) 
		//However this is needed for daylight saving time detection.
		var date = new Date(dateString); 
		return date;
	},
	
	//Assumes a correctly formatted date/time (yyyy-mm-ddTHH:mm:ss)
	addCompanyTimeZone: function(dateString) {
		return this.addTimeZoneOffset(dateString, this.getCompanyTimeZoneNameOnly());
	},

	addTimeZoneOffset: function(dateString, timeZoneId) {
		var timeZone = this.getFullTimeZone(timeZoneId, this.getDateFromDateString(dateString));
		return dateString + timeZone.offset;
	},
	
	startOfDayUserTime: function(dateString) {		
		var date = new Date(dateString);
		date.setHours(0);
		date.setMinutes(0);
		date.setSeconds(0);
		date.setMilliseconds(0);
		return date;
	},

	startOfDayUTCTime: function(dateString) {		
		var date = new Date(dateString);
		date.setUTCHours(0);
		date.setUTCMinutes(0);
		date.setUTCSeconds(0);
		date.setUTCMilliseconds(0);
		return date;
	},	
	
	endCurrentMonth: function() {
		var today = new Date();
		var lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
		lastDayOfMonth.setUTCHours(23);
		lastDayOfMonth.setUTCMinutes(59);
		lastDayOfMonth.setUTCSeconds(59);
		lastDayOfMonth.setUTCMilliseconds(999);
		return lastDayOfMonth;
	},
	
	endPreviousMonth: function() {
		var today = new Date();
		var lastDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 0);
		lastDayOfMonth.setUTCHours(23);
		lastDayOfMonth.setUTCMinutes(59);
		lastDayOfMonth.setUTCSeconds(59);
		lastDayOfMonth.setUTCMilliseconds(999);
		return lastDayOfMonth;
	},

	resolveYearMonthQuarterDates: function(ymqData) {
		if (!ymqData || ymqData.year == null || ymqData.year === '') {
			return null;
		}

		var year = parseInt(ymqData.year, 10);
		var startMonth;
		var endMonth;

		if (ymqData.month != null && ymqData.month !== '') {
			startMonth = parseInt(ymqData.month, 10);
			endMonth = startMonth;
		} else if (ymqData.quarter != null && ymqData.quarter !== '') {
			var quarter = parseInt(ymqData.quarter, 10);
			startMonth = (quarter - 1) * 3;
			endMonth = startMonth + 2;
		} else {
			startMonth = 0;
			endMonth = 11;
		}

		var begin = new Date(year, startMonth, 1, 0, 0, 0, 0);
		var end = new Date(year, endMonth + 1, 0, 23, 59, 59, 999);

		return {
			begin: begin.toISOString(),
			end: end.toISOString()
		};
	},
	
	startYearInPast: function() {
		var defaultStartDate = new Date();
		defaultStartDate.setUTCFullYear(defaultStartDate.getUTCFullYear() - 1);	
		defaultStartDate.setUTCMonth(0);	
		defaultStartDate.setUTCDate(1);	
		defaultStartDate.setUTCHours(0);
		defaultStartDate.setUTCMinutes(0);
		defaultStartDate.setUTCSeconds(0);
		defaultStartDate.setUTCMilliseconds(0);
		return defaultStartDate;
	},
	
	endOfDayCompanyTime: function(dateString) {		
		//user (yyyy-MM-dd)  
		//var date = new Date(dateString);
		
		var companyTimeZone = this.getCompanyTimeZone(this.getDateFromDateString(dateString));
//		var year = date.toLocaleString("default", { year: "numeric" });
//		var month = date.toLocaleString("default", { month: "2-digit" });
//		var day = date.toLocaleString("default", { day: "2-digit" });
		
		//(yyyy-MM-ddTHH:mm:ss-05:00)
		var dataRawString = dateString + 'T23:59:59' + companyTimeZone.offset;;
		//date = new Date(dataRawString);		
		return dataRawString;
	},
	
	endOfDayUserTime: function(dateString) {		
		var date = new Date(dateString);
		date.setHours(23);
		date.setMinutes(59);
		date.setSeconds(59);
		date.setMilliseconds(999);
		return date;
	},
	
	endOfDayUTCTime: function(dateString) {		
		var date = new Date(dateString);
		date.setUTCHours(23);
		date.setUTCMinutes(59);
		date.setUTCSeconds(59);
		date.setUTCMilliseconds(999);
		return date;
	},

	convert: function(d) {
        // Converts the date in d to a date-object. The input can be:
        //   a date object: returned without modification
        //  an array      : Interpreted as [year,month,day]. NOTE: month is 0-11.
        //   a number     : Interpreted as number of milliseconds
        //                  since 1 Jan 1970 (a timestamp) 
        //   a string     : Any format supported by the javascript engine, like
        //                  "YYYY/MM/DD", "MM/DD/YYYY", "Jan 31 2009" etc.
        //  an object     : Interpreted as an object with year, month and date
        //                  attributes.  **NOTE** month is 0-11.
        return (
            d.constructor === Date ? d :
            d.constructor === Array ? new Date(d[0],d[1],d[2]) :
            d.constructor === Number ? new Date(d) :
            d.constructor === String ? new Date(d) :
            typeof d === "object" ? new Date(d.year,d.month,d.date) : NaN
        );
    },
	
    compare: function(a,b) {
        // Compare two dates (could be of any type supported by the convert
        // function above) and returns:
        //  -1 : if a < b
        //   0 : if a = b
        //   1 : if a > b
        // NaN : if a or b is an illegal date
        // NOTE: The code inside isFinite does an assignment (=).
        return (
            isFinite(a=this.convert(a).valueOf()) &&
            isFinite(b=this.convert(b).valueOf()) ?
            (a>b)-(a<b) :
            NaN
        );
    },
	
    inRange: function(d,start,end) {
        // Checks if date in d is between dates in start and end.
        // Returns a boolean or NaN:
        //    true  : if d is between start and end (inclusive)
        //    false : if d is before start or after end
        //    NaN   : if one or more of the dates is illegal.
        // NOTE: The code inside isFinite does an assignment (=).
       return (
            isFinite(d=this.convert(d).valueOf()) &&
            isFinite(start=this.convert(start).valueOf()) &&
            isFinite(end=this.convert(end).valueOf()) ?
            start <= d && d <= end :
            NaN
        );
    },
	
	/**
	 * This Converts Aug2022 to a date yyyy-MM-dd
	 * @param {type} monthYear (MMMyyyy)
	 * @returns date
	 */
	monthYearParse: function(monthYear) {
		var monthNumber = {
			'Jan': 0,
			'Feb': 1,
			'Mar': 2,
			'Apr': 3,
			'May': 4,
			'Jun': 5,
			'Jul': 6,
			'Aug': 7,
			'Sep': 8,
			'Oct': 9,
			'Nov': 10,
			'Dec': 11
		};
		
		var monthCode = monthYear.substring(0, 3);
		var year = monthYear.substring(3);
		
		var monthDate = startOfDayLocalTime(new Date());
		monthDate.setDate(1);
		monthDate.setMonth(monthNumber[monthCode]);
		monthDate.setYear(year);
		
		return monthDate.getYear() + '-' + monthDate.getMonth() + '-' + monthDate.getDate();
	},
	
	/**
	 * Get timezone offset formated
	 * @param {type} inputDate
	 * @returns String +02:00
	 */
	getLocalTimeZoneOffset: function(inputDate) {
		  var tzo = -inputDate.getTimezoneOffset(),
				dif = tzo >= 0 ? '+' : '-',
				pad = function (num) {
					return (num < 10 ? '0' : '') + num;
				};
				
		return dif + pad(Math.floor(Math.abs(tzo) / 60)) +
				':' + pad(Math.abs(tzo) % 60);		
	},
	
	getLocalTimeZoneString: function(inputDate) {
		var allTime = inputDate.toLocaleTimeString('en-US', {
			timeZoneName: "short"
		});
		var timezone = allTime.substr(allTime.indexOf(' ')).replace('AM', '').replace('PM', '');
		return timezone;
	},
	
	currentDate: function() {
		return new Date();
	},
	
	datePlusHours: function(date, hours) {		
		return date.setHours(date.getHours() + hours);	
	},
	
	formatTimeOnly: function(date) {
		var newDate = date;
		if ((typeof date === 'number')) {
			newDate = new Date(date);
		}
		
		var hours = (newDate.getHours() < 10 ? '0' : '') + newDate.getHours();
		var minutes = (newDate.getMinutes() < 10 ? '0' : '') + newDate.getMinutes();
		var seconds = (newDate.getSeconds() < 10 ? '0' : '') + newDate.getSeconds();		
		return hours + ":" + minutes + ":" + seconds;
	}
		
};
